// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"4863881b","358":"e17c6f45","461":"034fd88b","808":"f4fae61c"}[chunkId] + ".css";
};